import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import AuthPage from "@/pages/AuthPage";
import MerchantDashboard from "@/pages/MerchantDashboard";
import VendorDashboard from "@/pages/VendorDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import MenuPage from "@/pages/MenuPage";
import KitchenPage from "@/pages/KitchenPage";
import SitePage from "@/pages/SitePage";
import SpinPage from "@/pages/SpinPage";
import QuiPayePage from "@/pages/QuiPayePage";
import McaCarPage from "@/pages/McaCarPage";
import SafeReviewPage from "@/pages/SafeReviewPage";
import PublicReviewPage from "@/pages/PublicReviewPage";
import PaymentSuccess from "@/pages/PaymentSuccess";

function getRedirectPath(role) {
  if (role === 'admin') return '/admin';
  if (role === 'vendor') return '/vendor';
  return '/dashboard';
}

function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: '#0F0F1A' }}>
      <div className="w-10 h-10 border-3 border-[#7C3AED] border-t-transparent rounded-full animate-spin" />
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  if (requiredRole && user.role !== requiredRole) {
    return <Navigate to={getRedirectPath(user.role)} replace />;
  }
  return children;
}

function AppRoutes() {
  const { user, loading } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={
        loading ? null : user ? <Navigate to={getRedirectPath(user.role)} replace /> : <AuthPage mode="login" />
      } />
      <Route path="/register" element={
        loading ? null : user ? <Navigate to={getRedirectPath(user.role)} replace /> : <AuthPage mode="register" />
      } />
      <Route path="/dashboard" element={
        <ProtectedRoute requiredRole="merchant"><MerchantDashboard /></ProtectedRoute>
      } />
      <Route path="/vendor" element={
        <ProtectedRoute requiredRole="vendor"><VendorDashboard /></ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute requiredRole="admin"><AdminDashboard /></ProtectedRoute>
      } />
      <Route path="/spin/:merchantId" element={<SpinPage />} />
      <Route path="/menu/:slug" element={<MenuPage />} />
      <Route path="/menu/:slug/cuisine/:token" element={<KitchenPage />} />
      <Route path="/site/:slug" element={<SitePage />} />
      <Route path="/qui-paye/:slug" element={<QuiPayePage />} />
      <Route path="/qui-paye" element={<QuiPayePage />} />
      <Route path="/facturation/mca-car" element={<McaCarPage />} />
      <Route path="/vendor/safe-review" element={<SafeReviewPage />} />
      <Route path="/vendor/filtre-avis" element={<Navigate to="/vendor/safe-review" replace />} />
      <Route path="/avis/:slug" element={<PublicReviewPage />} />
      <Route path="/payment-success" element={<PaymentSuccess />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}
